import React from "react";
import { Route } from "react-router-dom";
import StayTouch from "../../layout/StayTouch";
import DashboardBanner from "./DashboardBanner";
import ProfileSetting from "./ProfileSetting";
import TermsOfService from "./TermsOfService";
import OrderHistory from "./OrderHistory";
import OrderDetail from "./OrderDetail";
import AutoRenewal from "./AutoRenewal";
import AutoRenewalDetail from "./AutoRenewalDetail";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import { connect } from "react-redux";
import UpdatePassword from "./UpdatePassword";
class Dashboard extends React.Component {
  render() {
    const { isAuthenticated, user } = this.props.auth;
    return (
      <div>
        <DashboardBanner isAuthenticated={isAuthenticated} user={user} />
        <Route exact path="/dashboard" component={ProfileSetting} />
        <Route path="/dashboard/termsofservice" component={TermsOfService} />
        <Route path="/dashboard/orderhistory" component={OrderHistory} />
        <Route path="/dashboard/order/:id" component={OrderDetail} />
        <Route path="/dashboard/update/password" component={UpdatePassword} />
        <Route path="/dashboard/autorenewal" component={AutoRenewal} />
        <Route path="/dashboard/autorenewaldetail/:id" component={AutoRenewalDetail} />
        <StayTouch />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(mapStateToProps)(layoutWrapper(Dashboard));



// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js